import PropTypes from 'prop-types';
import React from 'react';
import InstructionsView from 'components/tools/InstructionsView';

const Instructions = ({nextView}) => <InstructionsView
  onSubmit={nextView}
  title='tools.merge.find.accounts'
  remember={[
    'tools.remember.account.physical',
    'tools.merge.calculate.percent',
    'tools.merge.match.duplicates',
    'tools.merge.before.merge',
    'tools.merge.merged.after',
  ]}
  instructions={[
    {
      title: 'tools.instructions.run.report',
      body: 'tools.merge.click.start',
    },
    {
      title: 'tools.instructions.review.report',
      body: 'tools.merge.all.duplicate',
    },
    {
      title: 'tools.merge.confirm.account',
      body: 'tools.merge.confirm.message',
    },
  ]}
/>;

Instructions.propTypes = {
  nextView: PropTypes.func.isRequired,
};

export default Instructions;
